import * as t from "react";
import { p as u } from "./index-efd35e77.js";
import { c as j } from "./package-metadata-9ad1330d.js";
var L = function(e, a, n) {
  n === void 0 && (n = {});
  var o = t.useCallback(function(i) {
    n.onMouseDown && n.onMouseDown.call(void 0, i), e.onMouseDown && e.onMouseDown.call(void 0, {
      target: a.current,
      syntheticEvent: i
    });
  }, [n.onMouseDown, e.onMouseDown, a]), l = t.useCallback(function(i) {
    n.onMouseUp && n.onMouseUp.call(void 0, i), e.onMouseUp && e.onMouseUp.call(void 0, {
      target: a.current,
      syntheticEvent: i
    });
  }, [n.onMouseUp, e.onMouseUp, a]), c = t.useCallback(function(i) {
    n.onClick && n.onClick.call(void 0, i), e.onClick && e.onClick.call(void 0, {
      target: a.current,
      syntheticEvent: i
    });
  }, [n.onClick, e.onClick, a]), s = t.useCallback(function(i) {
    n.onDoubleClick && n.onDoubleClick.call(void 0, i), e.onDoubleClick && e.onDoubleClick.call(void 0, {
      target: a.current,
      syntheticEvent: i
    });
  }, [n.onDoubleClick, e.onDoubleClick, a]), m = t.useCallback(function(i) {
    n.onMouseEnter && n.onMouseEnter.call(void 0, i), e.onMouseEnter && e.onMouseEnter.call(void 0, {
      target: a.current,
      syntheticEvent: i
    });
  }, [n.onMouseEnter, e.onMouseEnter, a]), d = t.useCallback(function(i) {
    n.onMouseLeave && n.onMouseLeave.call(void 0, i), e.onMouseLeave && e.onMouseLeave.call(void 0, {
      target: a.current,
      syntheticEvent: i
    });
  }, [n.onMouseLeave, e.onMouseLeave, a]), r = t.useCallback(function(i) {
    n.onMouseMove && n.onMouseMove.call(void 0, i), e.onMouseMove && e.onMouseMove.call(void 0, {
      target: a.current,
      syntheticEvent: i
    });
  }, [n.onMouseMove, e.onMouseMove, a]), f = t.useCallback(function(i) {
    n.onMouseOut && n.onMouseOut.call(void 0, i), e.onMouseOut && e.onMouseOut.call(void 0, {
      target: a.current,
      syntheticEvent: i
    });
  }, [n.onMouseOut, e.onMouseOut, a]), h = t.useCallback(function(i) {
    n.onMouseOver && n.onMouseOver.call(void 0, i), e.onMouseOver && e.onMouseOver.call(void 0, {
      target: a.current,
      syntheticEvent: i
    });
  }, [n.onMouseOver, e.onMouseOver, a]);
  return {
    onClick: c,
    onMouseUp: l,
    onMouseDown: o,
    onDoubleClick: s,
    onMouseEnter: m,
    onMouseLeave: d,
    onMouseMove: r,
    onMouseOut: f,
    onMouseOver: h
  };
}, z = {
  default: "",
  xsmall: "k-icon-xs",
  small: "k-icon-sm",
  medium: "k-icon-md",
  large: "k-icon-lg",
  xlarge: "k-icon-xl",
  xxlarge: "k-icon-xxl",
  xxxlarge: "k-icon-xxxl"
}, x = globalThis && globalThis.__assign || function() {
  return x = Object.assign || function(e) {
    for (var a, n = 1, o = arguments.length; n < o; n++) {
      a = arguments[n];
      for (var l in a)
        Object.prototype.hasOwnProperty.call(a, l) && (e[l] = a[l]);
    }
    return e;
  }, x.apply(this, arguments);
}, B = globalThis && globalThis.__rest || function(e, a) {
  var n = {};
  for (var o in e)
    Object.prototype.hasOwnProperty.call(e, o) && a.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var l = 0, o = Object.getOwnPropertySymbols(e); l < o.length; l++)
      a.indexOf(o[l]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[l]) && (n[o[l]] = e[o[l]]);
  return n;
}, I = t.forwardRef(function(e, a) {
  var n = e.className, o = e.name, l = e.themeColor, c = e.size, s = e.flip, m = e.style, d = e.id, r = e.tabIndex, f = B(e, ["className", "name", "themeColor", "size", "flip", "style", "id", "tabIndex"]), h = t.useRef(null), i = t.useRef(null);
  t.useImperativeHandle(h, function() {
    return {
      element: i.current
    };
  }), t.useImperativeHandle(a, function() {
    return h.current;
  });
  var M = t.useMemo(function() {
    return c || P.size;
  }, [c]), g = t.useMemo(function() {
    return s || P.flip;
  }, [s]), _ = t.useMemo(function() {
    var v;
    return j("k-icon", "k-font-icon", o && K(o), (v = {}, v["k-color-".concat(l)] = l, v["k-flip-h"] = g === "horizontal" || g === "both", v["k-flip-v"] = g === "vertical" || g === "both", v), z[M], n);
  }, [o, l, M, g, n]), k = L(e, h);
  return t.createElement("span", x({ ref: i }, f, k, { className: _, id: d, tabIndex: r, style: m, role: "presentation" }));
});
I.propTypes = {
  style: u.object,
  classNames: u.string,
  name: u.string,
  themeColor: u.oneOf([
    "inherit",
    "primary",
    "secondary",
    "tertiary",
    "info",
    "success",
    "error",
    "warning",
    "dark",
    "light",
    "inverse"
  ]),
  size: u.oneOf(["default", "xsmall", "small", "medium", "large", "xlarge", "xxlarge", "xxxlarge"]),
  flip: u.oneOf(["default", "horizontal", "vertical", "both"])
};
var P = {
  size: "default",
  flip: "default"
};
I.displayName = "KendoIcon";
var y = globalThis && globalThis.__assign || function() {
  return y = Object.assign || function(e) {
    for (var a, n = 1, o = arguments.length; n < o; n++) {
      a = arguments[n];
      for (var l in a)
        Object.prototype.hasOwnProperty.call(a, l) && (e[l] = a[l]);
    }
    return e;
  }, y.apply(this, arguments);
}, U = globalThis && globalThis.__rest || function(e, a) {
  var n = {};
  for (var o in e)
    Object.prototype.hasOwnProperty.call(e, o) && a.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var l = 0, o = Object.getOwnPropertySymbols(e); l < o.length; l++)
      a.indexOf(o[l]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[l]) && (n[o[l]] = e[o[l]]);
  return n;
}, E = t.forwardRef(function(e, a) {
  var n = e.children, o = e.className, l = e.svgClassName, c = e.icon, s = e.flip, m = e.id, d = e.tabIndex, r = e.size, f = e.style, h = e.svgStyle, i = e.themeColor, M = e.viewBox;
  e.name;
  var g = e.onClick, _ = U(e, ["children", "className", "svgClassName", "icon", "flip", "id", "tabIndex", "size", "style", "svgStyle", "themeColor", "viewBox", "name", "onClick"]), k = t.useRef(null);
  t.useImperativeHandle(a, function() {
    return {
      element: k.current
    };
  });
  var v = t.useMemo(function() {
    return c ? c.name : C.icon;
  }, [c]), N = t.useMemo(function() {
    return r || C.size;
  }, [r]), b = t.useMemo(function() {
    return s || C.flip;
  }, [s]), S = t.useMemo(function() {
    return M || C.viewBox;
  }, [M]), D = t.useMemo(function() {
    var O;
    return j("k-icon", "k-svg-icon", "k-svg-i-" + v, (O = {}, O["k-color-".concat(i)] = i, O["k-flip-h"] = b === "horizontal" || b === "both", O["k-flip-v"] = b === "vertical" || b === "both", O), z[N], o);
  }, [v, i, N, b, o]), R = t.useMemo(function() {
    return e.width && e.height ? y({ width: e.width, height: e.height }, f) : e.width ? y({ width: e.width, height: e.width }, f) : e.height ? y({ width: e.height, height: e.height }, f) : y({}, f);
  }, [e.width, e.height, f]);
  return t.createElement(
    "span",
    { className: D, style: R, ref: k, onClick: g },
    t.createElement("svg", y({ id: m, className: l, style: h, "aria-hidden": !0, tabIndex: d, focusable: !1, xmlns: "http://www.w3.org/2000/svg", viewBox: c ? c.viewBox : S, dangerouslySetInnerHTML: c ? { __html: c.content } : void 0 }, _), c ? void 0 : n)
  );
});
E.propTypes = {
  style: u.object,
  classNames: u.string,
  children: u.any,
  icon: u.object,
  themeColor: u.oneOf([
    "inherit",
    "primary",
    "secondary",
    "tertiary",
    "info",
    "success",
    "error",
    "warning",
    "dark",
    "light",
    "inverse"
  ]),
  size: u.oneOf(["default", "xsmall", "small", "medium", "large", "xlarge", "xxlarge", "xxxlarge"]),
  flip: u.oneOf(["default", "horizontal", "vertical", "both"])
};
var C = {
  size: "default",
  flip: "default",
  icon: "",
  viewBox: "0 0 24 24"
};
E.displayName = "KendoSvgIcon";
var T = t.createContext({ type: "svg" });
T.displayName = "KendoReactIconsContext";
var w = globalThis && globalThis.__assign || function() {
  return w = Object.assign || function(e) {
    for (var a, n = 1, o = arguments.length; n < o; n++) {
      a = arguments[n];
      for (var l in a)
        Object.prototype.hasOwnProperty.call(a, l) && (e[l] = a[l]);
    }
    return e;
  }, w.apply(this, arguments);
}, $ = globalThis && globalThis.__rest || function(e, a) {
  var n = {};
  for (var o in e)
    Object.prototype.hasOwnProperty.call(e, o) && a.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var l = 0, o = Object.getOwnPropertySymbols(e); l < o.length; l++)
      a.indexOf(o[l]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[l]) && (n[o[l]] = e[o[l]]);
  return n;
}, H = t.forwardRef(function(e, a) {
  var n, o, l = t.useContext(T), c = l.type, s = l.icons, m = e.icon, d = $(e, ["icon"]), r = c === "svg" ? ((n = e.icon) === null || n === void 0 ? void 0 : n.name) || e.name : e.name || ((o = e.icon) === null || o === void 0 ? void 0 : o.name);
  r = r && s && s[r] && typeof s[r] == "string" ? s[r] : r;
  var f = r && s && s[r] && typeof s[r] != "string" ? s[r] : m;
  return c === "svg" && f ? t.createElement(E, w({}, e, { icon: f, ref: a })) : t.createElement(I, w({}, d, { name: r, ref: a }));
});
H.displayName = "KendoIconWrap";
var A = function(e) {
  return e.replace(/^k-i-/, "");
}, K = function(e) {
  return "k-i-" + e;
}, Z = u.shape({
  name: u.string.isRequired,
  content: u.string.isRequired,
  viewBox: u.string.isRequired
}), F = {
  sizeMap: {
    small: "sm",
    medium: "md",
    large: "lg"
  },
  roundedMap: {
    small: "sm",
    medium: "md",
    large: "lg"
  }
};
export {
  H as I,
  F as k,
  Z as s,
  A as t,
  L as u
};
